module.exports = __webpack_public_path__ + "img/finder.f85a7f62.svg";